import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import ServicesMain from "./services";
import FooterTwo from "../../../layout/footers/footer-two";

const ServicePage = () => {
    return (
        <>
            <SEO pageTitle="Services"/>
            <HeaderTwo/>
            <BreadCrumb title="Services"
                        items={[
                            {label: "Service"},
                        ]}/>
            <ServicesMain/>
            <FooterTwo/>
        </>
    );
};

export default ServicePage;